import React from 'react';

import classNames from 'classnames';

import { FONT_SIZES } from '../../../constants/font.constants';


export const CodeFormatLabel = ({ 
  className,
  children,
  bgColor = 'border-light',
  textColor = 'brand',
  size = FONT_SIZES.SM,
  ...rest
}) => (
  <pre 
    className={classNames(`p-1 bg-${bgColor} text-${textColor} text-${size}`, className)}
    {...rest}
  >
    { children }
  </pre>
)

export default CodeFormatLabel;
